module Eseebase {
    export interface IStatusIconScope extends ng.IScope {
        mode: string;
        progress: number;
        onIconClick: Function;
        round: Function;
    }

    export class StatusIconDirective {
        public link: (scope: IStatusIconScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, ngModel: any) => void;
        public templateUrl = '/app/directives/status-icon.html';
        public scope = {
            mode: '=',
            progress: '=',
            onIconClick: '&'
        };
        public restrict = 'E';
        public require: string;
        public replace: any;

        constructor() {
            StatusIconDirective.prototype.replace = 'true';
            StatusIconDirective.prototype.link = (scope: IStatusIconScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, ngModel: any) => {
                scope.round = function(val: number) {
                    return Math.round(val);
                }
            };
        }

        public static Factory() {
            var directive = () => {
                return new StatusIconDirective();
            };

            directive['$inject'] = [];

            return directive;
        }
    }

    angular
        .module('eseebase')
        .directive('statusIcon', StatusIconDirective.Factory());
}